import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import BlogSearchForm from './BlogSearchForm';

const CategoryMenu = (props) => {
    const {
        categories,
        current_category,
        router,
        queryQuestion
    } = props;

    const onClickCategory = (name) => {
        router.push(`/blog?category=${name}`)
    }

    return (
        <section className="categories">
            <div className="container categories-menu">
                <BlogSearchForm
                                queryQuestion={queryQuestion}
                                category={current_category}
                            />
                <div className="row categories-menu__content">
                    <div className="col-xs-12 col-md-4 col-lg-2">
                        <span className="white-text"><strong>Blog Categories: </strong></span>
                    </div>
                    <div className="col-xs-12 col-md-3 col-lg-3">
                        <div className="dropdown">
                            <button className="btn btn-dropdown dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="caret"></span>
                                {current_category ? current_category : 'All Articles'}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <li><a className="dropdown-item" onClick={() => router.push('/blog')}>All Articles</a></li>
                                {categories.map((element, index) => (
                                    <li key={index}><a className="dropdown-item" onClick={() => onClickCategory(element.name)}>
                                        {element.name}
                                    </a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

CategoryMenu.propTypes = {
    categories: PropTypes.array,
    current_category: PropTypes.string,
}

export default withRouter(CategoryMenu)



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/CategoryMenu.js